import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './BlogPost.css';
import goIcon from '../../img/featured-imgs/go-icon.svg';

class BlogTemplate extends Component {
  render() {
    return (
      <div className="blogpost" >
        <Grid>
          <Row className="content-row">
            <Col md={8} xs={12} mdOffset={2} >
              {this.props.children}
            </Col>
          </Row>
        </Grid>
        <Grid>
          <Row className="social-row">
            <Col md={10} xs={12} mdOffset={1}>
              <h5>
                SHARE
              </h5>
              <div className="social-links">
                <a href={"http://twitter.com/share?text=@DistilledID&url=" + window.location.href} className="link">
                  Twitter
                </a>
                <a href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href} className="link">LinkedIn</a>
                <a href="https://www.facebook.com/sharer.php?s=100" className="link">Facebook</a>
              </div>
            </Col>
          </Row>
          <Row className="post-navigation">
            <Col Row className="buttons-container">
              <Col md={6} sm={6} xs={6}>
                <Link to={"/news/" + this.props.locations.previous.path} className="case-study-link">
                  <div className="navigation-control navigation-previous">
                    <div className="nav-content" id="left">
                      <div className="arrow-left">
                        <img src={goIcon} alt="previous" className="arrow-img" id="arrow-left" />
                      </div>
                      <div>
                        <span>Previous</span>
                        <h3>{this.props.locations.previous.title}</h3>
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
              <Col md={6} sm={6} xs={6}>
                <Link to={"/news/" + this.props.locations.next.path} className="case-study-link">
                  <div className="navigation-control navigation-next">
                    <div className="nav-content" id="right">
                      <div>
                        <span>Next</span>
                        <h3>{this.props.locations.next.title}</h3>
                      </div>
                      <div className="arrow-right">
                        <img src={goIcon} alt="next" className="arrow-img" id="arrow-right" />
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default BlogTemplate;



// WEBPACK FOOTER //
// ./src/components/common/BlogTemplate.js